import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="fade-in-up">Mohammad Khamis</h1>
            <h2 className="hero-subtitle fade-in-up">Technical Manager & Full Stack Developer</h2>
            <p className="hero-description fade-in-up">
              Passionate about building scalable backend systems, leading AI transformation initiatives, 
              and mentoring cross-functional teams. Expert in Node.js, AWS cloud solutions, and modern 
              development practices.
            </p>
            <div className="hero-buttons fade-in-up">
              <a href="#contact" className="btn">Get In Touch</a>
              <a href="#about" className="btn btn-secondary">Learn More</a>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-avatar">
              <div className="avatar-placeholder">MK</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
